import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { LOCAL_STORAGE_KEYS } from '../utils/common/local-storage-keys';
import { safeSSRZustandStorage } from '../utils/common/safe-ssr-zustand-storage';
import { createSelectors } from '../utils/zustand/createSelectors';

/**
 * 대표 구독 상태 타입
 */
interface MainSubscriptionState {
  /** 선택된 대표 구독 ID (null이면 첫 번째 구독 사용) */
  mainSubscriptionId: number | null;

  /** 대표 구독 ID 설정 */
  setMainSubscriptionId: (id: number) => void;

  /** 대표 구독 ID 초기화 */
  clearMainSubscriptionId: () => void;
}

/**
 * 대표 구독을 관리하는 Zustand store
 * - 마이페이지, 정기배송 메인, 장바구니, 마이냉장고에서 선택된 구독 관리
 * - localStorage에 persist하여 페이지 새로고침/재방문 시에도 유지
 * - 사용자가 명시적으로 선택한 대표 구독을 기억
 */
const useMainSubscriptionStoreBase = create<MainSubscriptionState>()(
  persist(
    (set) => ({
      mainSubscriptionId: null,

      setMainSubscriptionId: (id: number) => set({ mainSubscriptionId: id }),

      clearMainSubscriptionId: () => set({ mainSubscriptionId: null }),
    }),
    {
      name: LOCAL_STORAGE_KEYS.MAIN_SUBSCRIPTION,
      storage: safeSSRZustandStorage(),
    },
  ),
);

export const useMainSubscriptionStore = createSelectors(
  useMainSubscriptionStoreBase,
);
